import { createInstance } from '@optimizely/react-sdk'
import { isProd } from 'utils/environment'

const optimizely = createInstance({
    sdkKey: isProd ? 'QCe1mjSmjUYMjK6T4SDFo' : 'ExQ1LrMbqzKPKq9DXXgH5',
})

export default optimizely
